import request from "@/api/request";

//后台设置
export function getAll() {
  return request({
    url: `/app/systemSettings/getAll`,
    headers: {
      "Content-Type": "application/json",
    },
  });
}

//链接地址
export function clientGet() {
  return request({
    url: `/app/seriesSettings/clientGet?card=${localStorage.getItem(
      "meCardNum"
    )}`,
  });
}

//链接地址
export function clientGets(val) {
  return request({
    url: `/app/seriesSettings/clientGet?card=${val}`,
  });
}

//跳转页面
export function applyWebList() {
  return request({
    url: `/app/company/applyWebList`,
  });
}
